function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "2fv01jgh3a",
  d: "M0 0.2L18.84 0.2 18.84 16.98 0 16.98z"
}), /*#__PURE__*/React.createElement("path", {
  id: "4ueufjbo9c",
  d: "M4.58 -2L6.82 -2 6.82 2.46 4.58 2.46z"
}), /*#__PURE__*/React.createElement("path", {
  id: "rs9doew0be",
  d: "M11.98 -2L14.22 -2 14.22 2.46 11.98 2.46z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-172.000000, -110.000000) translate(171.999960, 109.000000) translate(0.000000, 3.199960)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "9i2j61tnmb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#2fv01jgh3a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#9B9EA9",
  d: "M16.36 14.14c0 .22-.18.4-.4.4H2.84c-.22 0-.4-.18-.4-.4V5.66h13.94v8.48h-.02zM15.96.2h-.92v1.14c0 1.08-.86 1.94-1.94 1.94s-1.94-.88-1.94-1.94V.2h-3.5v1.14c0 1.08-.88 1.94-1.94 1.94-1.08 0-1.94-.88-1.94-1.94V.2h-.92C1.28.2 0 1.48 0 3.06v11.06c0 1.58 1.28 2.86 2.86 2.86h13.12c1.58 0 2.86-1.28 2.86-2.86V3.06C18.82 1.48 17.54.2 15.96.2z",
  mask: "url(#9i2j61tnmb)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "8z7e4164od",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#4ueufjbo9c"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#9B9EA9",
  d: "M5.7 2.46c.62 0 1.12-.5 1.12-1.12V-.88C6.82-1.5 6.32-2 5.7-2c-.62 0-1.12.5-1.12 1.12v2.22c0 .62.5 1.12 1.12 1.12",
  mask: "url(#8z7e4164od)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "9wha0uxw0f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#rs9doew0be"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#9B9EA9",
  d: "M13.1 2.46c.62 0 1.12-.5 1.12-1.12V-.88c0-.62-.5-1.12-1.12-1.12-.62 0-1.12.5-1.12 1.12v2.22c0 .62.5 1.12 1.12 1.12",
  mask: "url(#9wha0uxw0f)"
})))));

function SvgCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.7732e4ba.svg";
export { ForwardRef as ReactComponent };